<template>
  <div class="page">
    <div>
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <van-field v-model="queryFormModel.no" :colon="true" label="订单号" placeholder="请输入订单号" type="digit"/>
          <van-field v-model="queryFormModel.keyword" :colon="true" label="店员" placeholder="请输入店员ID或店员名称"/>
          <van-field
              :colon="true"
              :value="queryFormModel.status"
              clickable
              label="订单状态"
              placeholder="请选择"
              readonly
              @click="openPicker(statusColumn,(value)=>{queryFormModel.status = value})"
          />
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="onLoad(true)">查询</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index"
           style="margin: 10px 10px;background-color: #fff;border-radius:10px;padding: 5px">
        <div class="top flex align-center justify-between">
          <span><van-icon name="orders-o" size="16px"/> {{ item.no }}</span>
          <van-tag v-if="item.status == 0" plain type="warning">待确认</van-tag>
          <van-tag v-if="item.status == 1" plain type="success">已确认</van-tag>
        </div>
        <div class="middle" size="large" @click="gotoDetail(item.id)">
          <div class="clerk-item">
            <div class="left">
              <div class="left-head">
                <van-image round width="70px" height="70px" :src="item.avatarUrl"></van-image>
              </div>
              <div class="left-content">
                <!--名称 -->
                <div class="clerkName">
                  <span>{{ item.clerkName }}</span>
                </div>
                <!-- 详情 -->
                <div class="details">
                  <div>
                    <template v-if="item.status==0">下单时间：{{formatDate(item.startTime, 'YYYY-MM-DD HH:mm:ss') }}</template>
                    <template v-if="item.status==1">确认时间：{{formatDate(item.clerkConfirmTime, 'YYYY-MM-DD HH:mm:ss') }}</template>
                    <!--<template v-if="item.status==1">完成时间：{{ formatDate(item.endTime, 'YYYY-MM-DD HH:mm:ss') }}</template>-->
                  </div>
                  <div>服务内容：{{ item.itemContent }}</div>
                  <div>订单金额：{{ formatPrice(item.totalAmount) }}</div>
                </div>
              </div>
            </div>
            <div class="right">
            </div>
          </div>
        </div>
        <div class="bottom flex justify-end">
          <template v-if="item.status==0">
            <van-button @click="gotoUpdate(item.id)" round size="small"
                        style="margin-right: 10px;">
              <a>修改订单</a>
            </van-button>
          </template>
          <template>
            <van-button @click="deleteOutOrder(item.id)" round size="small"
                        style="margin-right: 10px;border-color: red">
              <span style="color: red">删除订单</span>
            </van-button>
          </template>


        </div>
      </div>

    </van-list>
    <van-popup v-model="picker.show" position="bottom" round>
      <van-picker
          :columns="picker.columns"
          show-toolbar
          @cancel="onPickerCancel"
          @confirm="onPickerConfirm"
      />
    </van-popup>
    <div>
      <van-button @click="gotoCreate()" style="position: fixed;bottom: 0;left: 0;" color="#1989fa"  size="large">添加外部订单</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Button,
  List,
  Cell,
  CellGroup,
  Tag,
  Dialog,
  Collapse,
  CollapseItem,
  Field,
  Popup,
  Picker,
  Image,
  Icon,
  Checkbox, CheckboxGroup, Toast
} from 'vant';
import moment from 'moment';
import Decimal from 'decimal.js';
import {getOrderList, deleteOutOrder} from '@/api/kf/out-order';

Vue.use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Dialog)
    .use(Image)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Collapse)
    .use(CollapseItem)
    .use(Field)
    .use(Popup)
    .use(Picker)
    .use(Icon)
    .use(Toast)

export default {
  name: 'out-order-list',
  components: {},
  data() {
    return {
      activeNames: [1],
      queryFormModel: {
        no: null,
        keyword: null,
        status: null
      },
      picker: {
        show: false,
        columns: [],
        onConfirm: null,
        onCancel: null
      },
      statusMap: {
        '待确认': 0,
        '已确认': 1
      },
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  computed: {
    statusColumn() {
      return Object.keys(this.statusMap)
    },
  },
  watch:{
    '$route' () {
      //当路由发生变化，刷新页面
      this.onLoad(true)
    }
  },
  methods: {
    //跳转页面
    gotoDetail(id) {
      this.$router.push('/kf/order/out-order-detail/' + id)
    },
    gotoUpdate(id) {
      this.$router.push('/kf/out-order-update/' + id)
    },
    gotoCreate() {
      this.$router.push('/kf/out-order-entry')
    },
    //删除订单
    deleteOutOrder(id) {
      Dialog.confirm({
        title: '确定要删除该订单?'
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        deleteOutOrder(
            id
        ).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: '删除订单成功',
              confirmButtonText: '确定'
            }).then(() => {
              this.list.some((item, i) => {
                if (item.id === id) {
                  this.list.splice(i, 1)
                  return true;
                }
              })
            })
          } else {
            Dialog.alert({
              title: '删除订单失败,请稍后重试'
            })
          }
        })
      })
    },

    //加载数据
    onLoad(resetPage) {
      this.activeNames = []
      this.loading = true
      if (resetPage) {
        this.pageNo = 1;
        this.list = []
      }
      let {
        no,
        keyword,
        status,
      } = this.queryFormModel

      if (status != null) {
        status = this.statusMap[status]
      }
      getOrderList(
          no,
          keyword,
          status,
          this.pageNo,
          this.pageSize).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          if (data.hasNextPage) {
            this.listFinished = false;
          } else {
            this.listFinished = true;
          }
          for (let i in data.list) {
            let user = data.list[i];
            this.list.push(user)
          }
        } else {
          this.listFinished = true;
          Dialog.alert({
            title: '加载订单失败',
            message: data.msg
          })
        }
        this.pageNo++;
      })
    },
    //选择
    openPicker(columns, onConfirm, onCancel) {
      this.picker.columns = columns
      this.picker.onConfirm = onConfirm
      if (!onCancel) {
        onCancel = () => {
          onConfirm(null)
        }
      }
      this.picker.onCancel = onCancel;
      this.picker.show = true
    },
    onPickerConfirm(value) {
      if (this.picker.onConfirm) {
        this.picker.onConfirm(value)
      }
      this.picker.show = false
    },
    onPickerCancel(value) {
      if (this.picker.onCancel) {
        this.picker.onCancel(value)
      }
      this.picker.show = false
    },
    //计算公式
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
  },
  mounted() {
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>
.page{
  background-color: #f6f6f8;
  .top {
    padding: 5px 10px;
  }
  .middle {
    padding: 0 10px;
    margin: 5px;
    .clerk-item {
      display: flex;
      align-items: center;

      .left {
        flex: 1;
        display: flex;

        .left-head {
          margin-right: 10px;
        }

        .left-content {
          .clerkName {
            font-size: 14px;
            font-weight: bold;
          }

          .details {
            margin: 5px 0;
            height: 16px;
            line-height: 16px;
            font-size: 12px;
            color: #999999;
          }
        }
      }

      .right {
        text-align: right;
        min-width: 30px;

        .total-amount {
          color: #333;
        }
      }
    }
  }
  .bottom {
    padding: 0px 0px 5px;
  }
}



</style>
